import HTTP from "@/_helpers/http";
import { PUBLIC_LOGIN__MUTATIONS } from '../mutation-types'
import { PUBLIC_LOGIN__API } from '@/_helpers/urls'
import { PUBLIC_LOGIN__ACTIONS } from '../action-types'

// State
const state = {
    info: null,
};

//Getters
const getters = {};

//Mutations
const mutations = {
    [PUBLIC_LOGIN__MUTATIONS.LOGINPAGEINFO](state, data) {
        state.info = data;
        localStorage.setItem('loginPageInfo', JSON.stringify(data));
    },
};

// Actions
const actions = {
    async [PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]({ commit, state }) {
        try {
            const url = `${PUBLIC_LOGIN__API.LOGINPAGEINFO}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(PUBLIC_LOGIN__MUTATIONS.LOGINPAGEINFO, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};
